import { authorize as publicAuthorize } from './captcharator-v1-captcha-entity-captcha.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const authorize: MaybeContext<
  BuildRESTFunction<typeof publicAuthorize> & typeof publicAuthorize
> = /*#__PURE__*/ createRESTModule(publicAuthorize);

export {
  CaptchaEntity,
  CaptchaRequest,
  CaptchaResponse,
  Errors,
  AssessmentResponse,
} from './captcharator-v1-captcha-entity-captcha.universal.js';
